// CMP-Avatar (Lot 1b) : photo ou initiales. Séparé de Content.tsx pour que la coquille (TopBar) n'embarque pas les
// onglets, accordéons et pagination dans le JavaScript initial (budget ≤ 200 Ko gzip, lot F5).
import { cn } from '@/lib/cn';
import { initials } from '@/lib/text';

const AVATAR_SIZE = { 24: 'size-6 text-[10px]', 32: 'size-8 text-[13px]', 36: 'size-9 text-small', 40: 'size-10 text-small', 48: 'size-12 text-h4', 64: 'size-16 text-h3' } as const;

/** Photo ou initiales sur fond chaud ; compte désactivé : grisé (initiales en texte secondaire, contraste AA conservé). */
export function Avatar({ name, src, size = 32, disabled }: { name: string; src?: string | null; size?: keyof typeof AVATAR_SIZE; disabled?: boolean }) {
  return src ? (
    <img src={src} alt={name} loading="lazy" className={cn('shrink-0 rounded-full object-cover', AVATAR_SIZE[size], disabled && 'grayscale')} />
  ) : (
    <span role="img" aria-label={name} className={cn('flex shrink-0 items-center justify-center rounded-full bg-surface-2 font-bold text-text', AVATAR_SIZE[size], disabled && 'border border-dashed border-border-strong bg-surface text-text-2')}>
      {initials(name)}
    </span>
  );
}
